import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import rootReducer from './reducers/index';

const bindMiddleware = middleware => {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        const { composeWithDevTools } = require('redux-devtools-extension');
        return composeWithDevTools(applyMiddleware(...middleware));
    }
    return applyMiddleware(...middleware);
};

const makeStore = (initialState /* , options */) => {
    // console.log('initialState', initialState);
    return createStore(rootReducer, initialState, bindMiddleware([thunkMiddleware]));
};

export default makeStore;
